module.exports = __webpack_public_path__ + "img/wifi2.2feb49f6.svg";